// src/components/PreferenzeDispositivo.js
// Riquadro «Questo dispositivo» in Impostazioni → Profilo: testo più grande e vibrazione di
// conferma (utils/preferenzeDispositivo.js). Valgono solo per il telefono/computer in uso.
import React, { useState } from "react";
import {
  DIMENSIONI_TESTO, dimensioneTesto, impostaDimensioneTesto, eDispositivoTouch,
  vibrazioneAttiva, impostaVibrazione, vibrazioneSupportata, vibra,
} from "../utils/preferenzeDispositivo";

const scelta = (attiva) => ({
  padding: "8px 14px", borderRadius: 8, cursor: "pointer", fontFamily: "'Inter',sans-serif", fontWeight: 700,
  border: `1px solid ${attiva ? "#7c3aed" : "#e5e7eb"}`, background: attiva ? "#ede9fe" : "#fff", color: attiva ? "#6d28d9" : "#374151",
});

export default function PreferenzeDispositivo() {
  const [testo, setTesto] = useState(dimensioneTesto());
  const [vibrazione, setVibrazione] = useState(vibrazioneAttiva());
  const touch = eDispositivoTouch();
  return (
    <div style={{ background: "#fff", border: "1px solid #e5e7eb", borderRadius: 12, padding: 20, marginBottom: 16 }}>
      <h3 style={{ fontSize: 14, fontWeight: 700, marginBottom: 4 }}>📱 Questo dispositivo</h3>
      <p style={{ fontSize: 12, color: "#6b7280", margin: "0 0 14px", lineHeight: 1.5 }}>
        Scelte che valgono solo per il telefono o il computer che stai usando ora.
      </p>

      <div style={{ fontSize: 13, fontWeight: 600, color: "#374151", marginBottom: 6 }}>Dimensione del testo</div>
      {touch ? (
        <>
          <div style={{ display: "flex", gap: 8, flexWrap: "wrap" }}>
            {DIMENSIONI_TESTO.map(d => (
              <button key={d.id} type="button" onClick={() => { setTesto(d.id); impostaDimensioneTesto(d.id); }}
                style={{ ...scelta(testo === d.id), fontSize: Math.round(12 * d.scala) }}>{d.etichetta}</button>
            ))}
          </div>
          <div style={{ fontSize: 11, color: "#9ca3af", marginTop: 6 }}>Scritte, pulsanti e campi più grandi: comodo con i guanti, al sole o se si vede meno bene.</div>
        </>
      ) : (
        <div style={{ fontSize: 12, color: "#6b7280" }}>Sul computer usa lo zoom del browser: <strong>Ctrl</strong> e <strong>+</strong> (su Mac <strong>Cmd</strong> e <strong>+</strong>). Sul telefono qui trovi «Grande» e «Molto grande».</div>
      )}

      <div style={{ fontSize: 13, fontWeight: 600, color: "#374151", margin: "16px 0 6px" }}>Vibrazione di conferma</div>
      {vibrazioneSupportata() ? (
        <label style={{ display: "flex", alignItems: "center", gap: 8, fontSize: 13, color: "#374151", cursor: "pointer" }}>
          <input type="checkbox" checked={vibrazione}
            onChange={e => { setVibrazione(e.target.checked); impostaVibrazione(e.target.checked); if (e.target.checked) vibra("ok"); }} />
          Un colpetto quando salvi, timbri o firmi; due brevi se qualcosa non è andato
        </label>
      ) : (
        <div style={{ fontSize: 12, color: "#6b7280" }}>Questo dispositivo non permette alle pagine web di vibrare (succede su iPhone e sui computer).</div>
      )}
    </div>
  );
}
